<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      :show-save-button="false"
      unit="退款管理"
      id-key="AccountId"
      :data="data"
      form-label-width="85px"
      :save-func="api.refund"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      close-on-saved
      :form-rules="rules"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:8">
            <el-form-item label="学号">
              <span>{{data.StudentNumber}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="姓名">
              <span>{{data.FullName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="卡号">
              <span>{{data.CardNumber}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:8">
            <el-form-item label="账户余额">
              <span>{{data.GiveBalance + data.Balance}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="赠送余额">
              <span>{{data.GiveBalance}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="充值余额">
              <span>{{data.Balance}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="isMB?24:8">
            <el-form-item label="可退金额">
              <span style="color:#f11;">{{data.Balance}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="状态">
              <span v-if="data.Status==0">失效</span>
              <span v-else-if="data.Status==1">有效</span>
              <span v-else>挂失</span>
            </el-form-item>
          </el-col>
          <el-col :span="isMB?24:8">
            <el-form-item label="退款原因">
              <el-select size="mini" v-model="data.Reason">
                <el-option value="毕业结算"/>
                <el-option value="其他"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="原因详情" prop="Detail">
              <el-input type="textarea" v-model="data.Detail" placeholder="请填写原因详情"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="toSave(false)" type="danger" size="mini">退 款</el-button>
        <!-- <el-button @click="toSave(true)" type="primary" size="mini">保 存</el-button> -->
        <el-button @click="close" size="mini">取 消</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RefundFlowId: 0,
        StudentId: 0,
        StudentNumber: "",
        FullName: "",
        CardNumber: "",
        Balance: null,
        GiveBalance: null,
        Status: 0,
        TeacherId: 0,
        Amount: null,
        Reason: "毕业结算",
        Detail: "",
      },
      // isEdit: false,
      isSave: true,
      api: require("@/api/consume/account").default,
      isMB: this.$store.state.isMB,
      rules: {
        Detail: [{ required: true, message: "请填写原因详情" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
    },
    onEditOpened(row) {
      // this.isEdit = true
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"))
      this.data.TeacherId = loginInfo.UserId
      // this.data.TeacherName = loginInfo.UserName
      this.data.Amount = row.Balance
    },
    onBeforeSave() {
      // if(!this.isSave&&!this.data.Detail) {
      //   this.$message.error("请填写原因详情")
      //   return false
      // }
      return true;
    },
    toSave(type) {
      this.$confirm("确认退款吗？","提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.isSave = type;
        this.save();
      })
    },
  },
};
</script>
<style lang="scss">
</style>